var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C26.3896 2.50078e-07 34 7.38655 34 16.5C34 25.6134 26.3896 33 17 33C7.61039 33 0 25.6134 0 16.5C0 7.38655 7.61039 0 17 0ZM17 2.10645C8.80896 2.10645 2.16992 8.54987 2.16992 16.5C2.16992 24.4501 8.80896 30.8936 17 30.8936C25.191 30.8936 31.8301 24.4501 31.8301 16.5C31.8301 8.54987 25.191 2.10645 17 2.10645ZM17 15.4473C17.5993 15.4473 18.085 15.9183 18.085 16.5V24.9258C18.0848 25.5073 17.5992 25.9785 17 25.9785C16.4008 25.9785 15.9152 25.5073 15.915 24.9258V16.5C15.915 15.9183 16.4007 15.4473 17 15.4473ZM17.1943 7.7334C18.1053 7.82713 18.813 8.57325 18.8086 9.47852C18.8086 10.4476 17.9985 11.2344 17 11.2344C16.0015 11.2344 15.1914 10.4477 15.1914 9.47852C15.1915 8.50947 16.0016 7.72363 17 7.72363L17.1943 7.7334Z",
    fill: "#002FA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqPageIcon);
export default __webpack_public_path__ + "static/media/FaqPageIcon.c8d7d2da6aa9593733fa34041ef82a70.svg";
export { ForwardRef as ReactComponent };